export const Testimonial = [
    {
        name: "Penny Hamilton",
        detail: "Head of People, Wincanton",
        feedback: "The feedback from colleagues who engaged in the MindReset workplace trial was overwhelmingly positive. The majority of participants used the sleep app and reported a significant improvement in their sleeping habits, which they have continued to benifit from",
        stars: 5
    },
    {
        name: "Stuart Errington QFSM",
        detail: "Chief Fire Officer, County Durham & Darlington Fire & Rescue Service",
        feedback: "From an organisational perspective MindReset is a cost effective solution. We were extremely impressed with the scientific and academic knowledge and research behind the project and encouraged by the long-term solutions that were proposed. Staff feedback was extremely positive. County Durham and Darlington Fire and Rescue Service are proud to have been involved in this project and we are happy to recommend the app to other organisations.",
        stars: 5
    },
    {
        name: "Carol Jordan",
        detail: "HR Manager EBAC",
        feedback: "I am glad that we took part in this study and we've received some great feedback. The results show that it really does work.",
        stars: 5
    }
]